import { IP_RoomAutomation } from './types'
import { OverviewPanelWrapper } from '../../../components/OverviewPanelWrapper'
import { useGetObjectsChildren } from '../../../../hooks/useGetObjectsChildren';
import { IAutomationObject } from '../../../types';
import { Button, KIND, SIZE } from 'baseui/button';
import { schema as FloorSchema, IP_Floor } from '../P_Floor/types'
import { useNavigate } from 'react-router-dom';
import { SlLayers } from 'react-icons/sl';
import { RoomsOverviewPanel } from '../../../SubPlants/SP_Room/RoomsOverviewPanel';
import ActiveLightsPanel from '../../../Devices/Light/ActiveLightsPanel';
import OpenWindowPanel from '../../../Devices/WindowContact/OpenWindowPanel';
import { themedUseStyletron } from '../../../../theme/customTheme';
import { VerticalStackPanel } from '../../../../components/Layout/StackPanel';
import { RoomsTemperaturesAvgOnly } from '../../../SubPlants/SP_Room';
import OpenDoorPanel from '../../../Devices/Door/OpenDoorPanel';

export function OverviewPanel(props: IP_RoomAutomation) {
    const [css, theme] = themedUseStyletron();
    const { children, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId, props.id);

    const navigate = useNavigate();
    const floors = children?.filter((app: IAutomationObject) => app.schema === FloorSchema).sort((a: IP_Floor, b: IP_Floor) => (b.floorNumber || 0) - (a.floorNumber || 0));


    return (
        <OverviewPanelWrapper height={theme.appSizes.mediumAppHeight} icon={<SlLayers size={'100%'} color={theme.colors.backgroundPrimary}></SlLayers>} {...props}>
            <RoomsOverviewPanel parentId={props.id} resourceGroupId={props.resourceGroupId}></RoomsOverviewPanel>
            <ActiveLightsPanel parentId={props.id} resourceGroupId={props.resourceGroupId}></ActiveLightsPanel>
            <OpenWindowPanel parentId={props.id} resourceGroupId={props.resourceGroupId}></OpenWindowPanel>
            <OpenDoorPanel parentId={props.id} resourceGroupId={props.resourceGroupId}></OpenDoorPanel>
            <RoomsTemperaturesAvgOnly parentId={props.id} resourceGroupId={props.resourceGroupId}></RoomsTemperaturesAvgOnly>


            <VerticalStackPanel $height={'200px'} $alignItems={'center'}>
                {floors?.map((item: IAutomationObject, index: number) =>
                    <Button key={item.id} size={SIZE.compact} kind={KIND.secondary} onClick={(e) => { e.stopPropagation(); e.preventDefault(); navigate(`/objects/${item.resourceGroupId}/${item.id}`); }} >{item.description}</Button>
                )}
            </VerticalStackPanel>


        </OverviewPanelWrapper>
    );
}


